import styles from "./CustomInput.module.css";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { useState } from "react";

const CustomInput = ({
  showLabel = false,
  showSearchIcon = false, // Added parameter to show the search icon
  label,
  placeholder,
  className,
  onChange,
  name,
  value,
  inputRef,
  required = false,
  type = "text",
}) => {
  const [searchIconVisible, setSearchIconVisible] = useState(true);
  const [inputType, setInputType] = useState(type);

  const handleFocus = () => {
    setSearchIconVisible(false);
  };

  const handleBlur = () => {
    setSearchIconVisible(true);
  };

  const togglePasswordVisibility = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {showLabel ? <label htmlFor="">{label}</label> : null}
      <div style={{ position: "relative" }}>
        <input
          ref={inputRef}
          type={inputType}
          className={` ${className ?? null} ${styles.Input}`}
          placeholder={placeholder}
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
            if (value) {
              setSearchIconVisible(false);
            }
          }}
          name={name}
          value={value}
          required={required}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        {type === "password" && (
          <span
            onClick={togglePasswordVisibility}
            className={styles.togglePasswordIcon}
          >
            {inputType === "password" ? (
              <VisibilityOffIcon />
            ) : (
              <VisibilityIcon />
            )}
          </span>
        )}
        {showSearchIcon && !value ? ( // Show the search icon based on the showSearchIcon parameter using ternary operator
          <SearchIcon
            className="SearchIcon"
            style={{
              position: "absolute",
              left: 10,
              top: 10,
              display: searchIconVisible ? "block" : "none",
              color: "var(--color-secondary)",
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export const CustomSelectInput = ({
  showLabel = false,
  className,
  onChange,
  name,
  value,
  required = false,
  selectOptions,
  defaultOption,
}) => {
  return (
    <>
      {showLabel ? <label htmlFor=""></label> : null}
      <select
        className={` ${className ?? null} ${styles.dropMenuContainer}`}
        onChange={onChange}
        name={name}
        value={value}
        required={required}
      >
        <option value="">{defaultOption ?? "Select"}</option>
        {selectOptions?.map(({ value, option }) => (
          <option value={value} key={value}>
            {option}
          </option>
        ))}
      </select>
    </>
  );
};
export default CustomInput;
